import "./index.css"

const WeatherList = props => {
    const {WeatherData} = props
    const {temperature,humidity,windSpeed,condition,city} = WeatherData
    const {text,icon} = condition
    
    
    return (
        <div className="listContainer">
            <h1 className="city">Current Weather in {city}</h1>
            <p className="cityInfo">Temperature: {temperature}</p>
            <p className="cityInfo">Humidity: {humidity}</p>
            <p className="cityInfo">Wind Speed: {windSpeed}</p>
            <p className="cityInfo">Condition: {text}</p>
            <img src={icon} alt="weatherImage" className="weatherImage" />
        </div>
    )
}

export default WeatherList
